import axiosInstance from "./AxiosInstance";

// Create a new follow-up
export const createFollowUp = async (followUpData) => {
  return axiosInstance.post("/lead/addFollowup", followUpData);
};

// Get all follow-ups for a specific lead
export const getFollowUps = async (lead_id) => {
  return axiosInstance.post("/lead/LeadfollowupList", { lead_id });
};

// Format the follow-up response data
export function formatFollowUps(responseData) {
  if (!responseData) return [];

  if (Array.isArray(responseData)) {
    return responseData.map(followUp => ({
      ...followUp,
      followup_id: followUp.followup_id || followUp._id || followUp.id,
    }));
  }

  let followUps = [];
  for (let key in responseData) {
    if (responseData.hasOwnProperty(key)) {
      followUps.push({
        ...responseData[key],
        followup_id:
          responseData[key].followup_id ||
          responseData[key]._id ||
          responseData[key].id ||
          key,
      });
    }
  }

  console.log("formattedFollowUps:", followUps);
  return followUps;
}
